import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, provideAppInitializer} from '@angular/core'
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async'
import {provideRouter, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {appInitializer} from './application/app-initializer'
import {authInterceptor} from './application/auth.interceptor'
import {responseInterceptor} from './application/response.interceptor'
import {LOCAL_STORAGE} from './application/constants'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core'
import {LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS} from '@angular/material-luxon-adapter'
import {registerLocaleData} from '@angular/common'
import localeFr from '@angular/common/locales/fr'

registerLocaleData(localeFr)


export const appConfig: ApplicationConfig = {
  providers: [
    {provide: LOCAL_STORAGE, useValue: localStorage},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        floatLabel: 'always',
        subscriptSizing: 'dynamic'

      }
    },
    {
      provide: MAT_LUXON_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: false, firstDayOfWeek: 1}
    },
    {
      provide: MAT_DATE_LOCALE, useValue: 'sv-SE'
    },
    {
      provide: DateAdapter,
      useClass: LuxonDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS},
    provideAppInitializer(() => appInitializer()),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([responseInterceptor, authInterceptor])),
    provideAnimationsAsync()
  ]
}
